/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable

import androidx.compose.runtime.Composable
import kotlinx.collections.immutable.persistentListOf
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import systems.frictionless.impulse.browser.composable.component.CenteredOnScreen
import systems.frictionless.impulse.browser.composable.component.ContentContainer
import systems.frictionless.impulse.browser.composable.component.HiImImpulse
import systems.frictionless.impulse.browser.composable.component.Text
import systems.frictionless.impulse.browser.composable.component.WhiteBox
import systems.frictionless.impulse.browser.ext.id
import systems.frictionless.impulse.browser.id.HtmlId
import systems.frictionless.impulse.browser.style.AppStyleSheet
import systems.frictionless.impulse.viewmodel.IntroSectionViewModel

@Composable
fun IntroSection(
    @Suppress("UNUSED_PARAMETER") introSectionViewModel: IntroSectionViewModel,
    action: () -> Unit
) {
    ContentContainer(
        mainContainerCssClass = AppStyleSheet.intro,
        mainContentContainerId = HtmlId.SectionIntro,
        mainContent = {
            CenteredOnScreen(classes = persistentListOf(AppStyleSheet.ignoreCenteringOnMobile)) {
                HiImImpulse()
                WhiteBox(classes = arrayOf(AppStyleSheet.introList, AppStyleSheet.narrowBox)) {
                    P { Text("There are five sections:") }
                    Ol {
                        IntroItem("Introduction")
                        IntroItem("Sign In")
                        IntroItem("Demographics")
                        IntroItem {
                            Text("Questions")
                            Span(attrs = {
                                classes(AppStyleSheet.introItemNote)
                            }) {
                                Text("About 50 questions on your behaviors and environment, which will take around 10 minutes.")
                            }
                        }
                        IntroItem {
                            Text("Insights")
                            Span(attrs = {
                                classes(AppStyleSheet.introItemNote)
                            }) {
                                Text("A report interpreting your results to provide personalized strategies.")
                            }
                        }
                    }
                    Div {
                        Button(attrs = {
                            classes(AppStyleSheet.blueButton)
                            id(HtmlId.PrimaryButton)
                            onClick {
                                action.invoke()
                            }
                        }) {
                            Text("Let's Start!")
                        }
                    }
                }
            }
        }
    )
}

@Composable
private fun IntroItem(s: String) {
    Li(attrs = {
        classes(AppStyleSheet.introItem)
    }) {
        Text(s)
    }
}

@Composable
private fun IntroItem(block: @Composable () -> Unit) {
    Li(attrs = {
        classes(AppStyleSheet.introItem)
    }) {
        block()
    }
}
